import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';

export type DeleteStrategyStepTemplate = {
  strategyStepTemplateId: number;
};

export default function useDeleteStrategyStepTemplate() {
  const queryClient = useQueryClient();

  const deleteStrategyStepTemplate = ({
    strategyStepTemplateId,
  }: DeleteStrategyStepTemplate) => {
    const request: Request = {
      url: `${ENDPOINTS.strategy.stepTemplate}`,
      config: {
        method: 'delete',
        data: { strategyStepTemplateId },
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    CronoError,
    DeleteStrategyStepTemplate
  >(deleteStrategyStepTemplate, {
    onSettled: (data, error, variables) => {
      queryClient.invalidateQueries([ENDPOINTS.strategy.main]);
      queryClient.invalidateQueries([ENDPOINTS.strategy.search]);
      queryClient.invalidateQueries([ENDPOINTS.strategy.details]);
    },
  });

  return { data, mutate, ...rest };
}
